// extracted by mini-css-extract-plugin
export default {"card":"LicenseCard_card__6fzUj","rowHeader":"LicenseCard_rowHeader__T0pNp","row":"LicenseCard_row__SivKR"};